import { Form } from './';
import { formPropTypes } from './common';

import React from 'react';
import { get } from 'lodash';

const ConnectForm = ({ formProps, values, onInputChange }) => (
  <Form {...formProps}>
    <Form.Group>
      <Form.Input
        label="Server address"
        name="address"
        value={get(values, 'address', '')}
        onChange={onInputChange}
        required
      />
      <Form.Input
        label={
          <label>
            PIN code <small>(6 digits)</small>
          </label>
        }
        name="pin"
        value={get(values, 'pin', '')}
        onChange={onInputChange}
        pattern="[0-9]{6}"
        placeholder="123..."
        required
      />
    </Form.Group>
  </Form>
);

ConnectForm.propTypes = formPropTypes;

export default ConnectForm;



// WEBPACK FOOTER //
// ./src/components/ConnectForm.js